module.exports = __webpack_public_path__ + "img/blog-cv-4-x1.60490936.webp";